import { axiosInstance } from '../request';
/* DOCUMENTS EPs */
export const getDocuments = async () => {
    const response = await axiosInstance.get('/api/v1/documents?page_size=10000');
    return response.data;
};
export const uploadDocument = async (data) => {
    const fd = new FormData();
    fd.append('file', data.file);
    fd.append('title', data.file.name);
    fd.append('is_search_enabled', 'true');
    const response = await axiosInstance.post('/api/v1/documents/file', fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            data.progressCallBack?.(progressEvent);
        }
    });
    return response.data;
};
export const downloadDocument = async (id) => {
    const response = await axiosInstance.get(`/api/v1/documents/${id}/file`, {
        responseType: 'blob'
    });
    return response.data;
};
export const downloadDocumentAsMd = async (id) => {
    const response = await axiosInstance.get(`/api/v1/documents/${id}/markdown`, {
        responseType: 'blob'
    });
    return response.data;
};
export const deleteDocument = async (id) => {
    await axiosInstance.delete(`/api/v1/documents/${id}`);
};
/* CONTEXT DOCUMENTS EPs */
export const getContextDocuments = async () => {
    const response = await axiosInstance.get('/api/v1/documents/temporal/');
    return response.data;
};
export const uploadContextDocument = async (data) => {
    const fd = new FormData();
    fd.append('file', data.file);
    fd.append('title', data.file.name);
    await axiosInstance.post('/api/v1/documents/temporal/file', fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            data.progressCallBack?.(progressEvent);
        }
    });
};
export const attachContextDocument = async (id) => {
    await axiosInstance.post(`/api/v1/documents/temporal/attach/${id}`);
};
export const deleteContextDocument = async (id) => {
    await axiosInstance.delete(`/api/v1/documents/temporal/${id}`);
};
//# sourceMappingURL=documents.api.js.map